import { Stack, Text } from "@mantine/core";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import CPTStimuliAndResponseComponent from "../../../../../../testContainer/common/CPTStimuliAndResponseComponent";
import CPTSectionHeader from "./CPTSectionHeader";
import { buildStageBuckets } from "../utils/cptStageMetrics";
import type { ContinuousPerformanceStageEvent, Stimulus, StimulusResponse } from "types/tests";

interface CPTTrialScatterSectionProps {
  stageEvents?: ContinuousPerformanceStageEvent[];
  stimuli?: Stimulus[] | null;
  responses?: StimulusResponse[] | null;
  sectionNumber?: number;
}

const CPTTrialScatterSection: React.FC<CPTTrialScatterSectionProps> = ({
  stageEvents,
  stimuli,
  responses,
  sectionNumber,
}) => {
  const { t } = useTranslation();
  const ns = "extraTests.continuousPerformance.result.scatter";
  const stageBoundaries = useMemo(() => {
    const buckets = buildStageBuckets(stageEvents);
    // Interior boundaries only — the chart edges already delimit the first and last stage.
    return buckets.slice(1).map((bucket) => bucket.startTime);
  }, [stageEvents]);
  return (
    <Stack gap="md">
      <Stack gap={4}>
        <CPTSectionHeader number={sectionNumber} title={t(`${ns}.title`)} />
        <Text size="sm" c="dimmed" lh={1.4}>
          {t(`${ns}.description`)}
        </Text>
      </Stack>
      <CPTStimuliAndResponseComponent
        stimuli={stimuli}
        responses={responses}
        stageBoundaries={stageBoundaries}
      />
    </Stack>
  );
};

export default CPTTrialScatterSection;
